import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pulse_loader = _resolveComponent("pulse-loader")!

  return (_openBlock(), _createElementBlock("button", {
    "data-test-id": "button",
    class: _normalizeClass(["py-4 flex justify-center items-center", [_ctx.getVariant, _ctx.disabled, _ctx.getSize, _ctx.getElevation, _ctx.getRounded]]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_pulse_loader, {
          key: 0,
          "data-test-id": "loading",
          color: "#ffffff"
        }))
      : _renderSlot(_ctx.$slots, "default", {
          key: 1,
          dataTestId: "slot"
        })
  ], 2))
}